import React, { useState } from 'react';
import { useTheme } from '@emotion/react';
import { type EmotionTheme } from '@bbkFunnel/pages/theme';
import Icon from '@bbkFunnelUtils/icon';
import { TextField } from './textfield-submit-btn';

type Props = {
  valueToType: string;
  placeholder: string;
  handleSubmit: CallableFunction;
};
export const DeleteTextField: React.FC<Props> = (props) => {
  const theme = useTheme() as EmotionTheme;
  const { valueToType, placeholder, handleSubmit } = props;
  const [deleteValue, setDeleteValue] = useState('');

  const isDeleteTyped = (): boolean => {
    const regexCheck = new RegExp(`^${valueToType}$`, 'gi');
    return deleteValue.match(regexCheck) !== null;
  };

  const onInputChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setDeleteValue(e.target.value);
  };

  const onSubmit = (): void => {
    if (isDeleteTyped()) {
      handleSubmit();
    }
  };

  const onKeyPress: React.KeyboardEventHandler<HTMLInputElement> = (e) => {
    if (e.key === 'Enter') {
      onSubmit();
    }
  };

  const submitBtn = (
    <div
      onClick={onSubmit}
      role="button"
      tabIndex={0}
      onKeyPress={onKeyPress}
      style={
        isDeleteTyped()
          ? { fill: theme.primaryColor }
          : { opacity: 0.5, fill: '#B2B2B2' }
      }
    >
      <Icon name="arrowLeft" classNames="deleteTextArrow" />
    </div>
  );

  return (
    <TextField
      placeholder={placeholder}
      name="delete"
      value={deleteValue}
      handler={onInputChange}
      handleKeyPress={onKeyPress}
      submitIconBtn={submitBtn}
    />
  );
};
